import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=46f3eede&"
import script from "./PageLoading.vue?vue&type=script&lang=js&"
export * from "./PageLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f3eede')) {
      api.createRecord('46f3eede', component.options)
    } else {
      api.reload('46f3eede', component.options)
    }
    module.hot.accept("./PageLoading.vue?vue&type=template&id=46f3eede&", function () {
      api.rerender('46f3eede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/PageLoading.vue"
export default component.exports